type TranslationKeys = {
  // Nav
  "nav.book": string;
  "nav.findStore": string;
  "nav.eyeTest": string;
  "nav.stores": string;
  "nav.glasses": string;
  "nav.prices": string;
  "nav.howItWorks": string;
  "nav.help": string;
  "nav.whatsapp": string;
  "nav.careers": string;
  // Hero
  "hero.title": string;
  "hero.subtitle": string;
  "hero.cta": string;
  "hero.ctaSecondary": string;
  // Packages
  "packages.title": string;
  "packages.from": string;
  // Store
  "store.nearest": string;
  "store.findStore": string;
  "store.openingHours": string;
  // Trust
  "trust.countries": string;
  "trust.branches": string;
  "trust.freeTest": string;
  // Booking
  "booking.title": string;
  "booking.selectBranch": string;
  "booking.selectBranchSingle": string;
  "booking.selectDate": string;
  "booking.selectTime": string;
  "booking.yourName": string;
  "booking.yourPhone": string;
  "booking.confirm": string;
  "booking.confirmed": string;
  "booking.confirmedMsg": string;
  "booking.bringPrescription": string;
  "booking.sendWhatsApp": string;
  // City
  "city.eyeTest": string;
  "city.branches": string;
  "city.faq": string;
  "city.heroTitle": string;
  "city.heroSubtitle": string;
  "city.heroPill": string;
  "city.heroFreeNote": string;
  "city.heroCta": string;
  "city.heroCtaSecondary": string;
  "city.branchesTitle": string;
  "city.branchBook": string;
  "city.branchMap": string;
  "city.branchHours": string;
  "city.contextTitle": string;
  "city.contextP1": string;
  "city.contextP2": string;
  "city.contextP3": string;
  "city.eyeTestTitle": string;
  "city.eyeTestDesc": string;
  "city.eyeTestDuration": string;
  "city.eyeTestBring": string;
  "city.eyeTestCta": string;
  "city.eyeTestStep1Title": string;
  "city.eyeTestStep2Title": string;
  "city.eyeTestStep3Title": string;
  "city.glassesTitle": string;
  "city.glassesDesc": string;
  "city.glassesCta": string;
  "city.pricesTitle": string;
  "city.pricesDesc": string;
  "city.pricesCta": string;
  "city.faq1Q": string;
  "city.faq1A": string;
  "city.faq2Q": string;
  "city.faq2A": string;
  "city.faq3Q": string;
  "city.faq3A": string;
  "city.faq4Q": string;
  "city.faq4A": string;
  "city.faq5Q": string;
  "city.faq5A": string;
  "city.faq6Q": string;
  "city.faq6A": string;
  // Global homepage
  "global.heroTitle": string;
  "global.heroSubtitle": string;
  "global.ctaCountry": string;
  "global.ctaBook": string;
  "global.chooseCountry": string;
  "global.bannerPrefix": string;
  "global.bannerAccept": string;
  "global.trustTitle": string;
  "global.trustCountries": string;
  "global.trustBranches": string;
  "global.trustFreeTest": string;
  "global.trustMobileMoney": string;
  "global.servicesTitle": string;
  "global.serviceEyeTestTitle": string;
  "global.serviceEyeTestDesc": string;
  "global.serviceEyeTestCta": string;
  "global.serviceGlassesTitle": string;
  "global.serviceGlassesDesc": string;
  "global.serviceGlassesCta": string;
  "global.serviceStoresTitle": string;
  "global.serviceStoresDesc": string;
  "global.serviceStoresCta": string;
  "global.glassesTitle": string;
  "global.glassesDesc": string;
  "global.glassesCtaPrimary": string;
  "global.glassesCtaSecondary": string;
  "global.howTitle": string;
  "global.howStep1Title": string;
  "global.howStep1Desc": string;
  "global.howStep2Title": string;
  "global.howStep2Desc": string;
  "global.howStep3Title": string;
  "global.howStep3Desc": string;
  "global.faqTitle": string;
  "global.faq1Q": string;
  "global.faq1A": string;
  "global.faq2Q": string;
  "global.faq2A": string;
  "global.faq3Q": string;
  "global.faq3A": string;
  "global.faq4Q": string;
  "global.faq4A": string;
  "global.faq5Q": string;
  "global.faq5A": string;
  "global.about": string;
  "global.footerRights": string;
  "global.bookRdv": string;
  // General
  "general.learnMore": string;
  "general.whatsapp": string;
  "general.call": string;
  "general.country": string;
  // Country page SEO
  "country.heroTitle": string;
  "country.heroSubtitle": string;
  "country.heroPill": string;
  "country.heroFreeNote": string;
  "country.proofIntro": string;
  "country.proofPriceFrom": string;
  "country.proofMobileMoney": string;
  "country.citiesTitle": string;
  "country.cityMicroDesc": string;
  "country.citySeeBranches": string;
  "country.eyeTestTitle": string;
  "country.eyeTestDesc": string;
  "country.eyeTestDuration": string;
  "country.eyeTestNoObligation": string;
  "country.eyeTestCta": string;
  "country.eyeTestHowItWorks": string;
  "country.glassesTitle": string;
  "country.glassesDesc": string;
  "country.glassesCta": string;
  "country.pricesTitle": string;
  "country.pricesPackage": string;
  "country.pricesFrom": string;
  "country.pricesCta": string;
  "country.faqTitle": string;
  "country.faq1Q": string;
  "country.faq1A": string;
  "country.faq2Q": string;
  "country.faq2A": string;
  "country.faq3Q": string;
  "country.faq3A": string;
  "country.faq4Q": string;
  "country.faq4A": string;
  "country.faq5Q": string;
  "country.faq5A": string;
  "country.faq6Q": string;
  "country.faq6A": string;
  "country.citiesCount": string;
  "country.citiesCountOne": string;
  "country.branchesCount": string;
  "country.branchesCountOne": string;
  "country.proofIntroOne": string;
  "country.proofPackFrom": string;
  "country.proofFrameFrom": string;
  "country.faq2AOne": string;
  // Editorial: Why Lapaire
  "country.whyTitle": string;
  "country.whySubtitle": string;
  "country.whyPillar1Title": string;
  "country.whyPillar1Desc": string;
  "country.whyPillar2Title": string;
  "country.whyPillar2Desc": string;
  "country.whyPillar3Title": string;
  "country.whyPillar3Desc": string;
  "country.whyPillar4Title": string;
  "country.whyPillar4Desc": string;
  // Editorial: How it works
  "country.journeyTitle": string;
  "country.journeySubtitle": string;
  "country.journey1Title": string;
  "country.journey1Desc": string;
  "country.journey2Title": string;
  "country.journey2Desc": string;
  "country.journey3Title": string;
  "country.journey3Desc": string;
  "country.journey4Title": string;
  "country.journey4Desc": string;
  // Glasses page
  "glasses.heroTitle": string;
  "glasses.heroSubtitle": string;
  "glasses.heroCta": string;
  "glasses.heroCtaSecondary": string;
  "glasses.filterAll": string;
  "glasses.filterWomen": string;
  "glasses.filterMen": string;
  "glasses.filterSun": string;
  "glasses.filterRimless": string;
  "glasses.filterNew": string;
  // Wizard filter
  "glasses.wizardQ1": string;
  "glasses.wizardQ2": string;
  "glasses.wizardQ3": string;
  "glasses.wizardQ4": string;
  "glasses.wizardAll": string;
  "glasses.wizardMen": string;
  "glasses.wizardWomen": string;
  "glasses.wizardOptical": string;
  "glasses.wizardSun": string;
  "glasses.wizardRimless": string;
  "glasses.wizardRound": string;
  "glasses.wizardRectangle": string;
  "glasses.wizardAviator": string;
  "glasses.wizardCatEye": string;
  "glasses.wizardReset": string;
  "glasses.productChoose": string;
  "glasses.inStock": string;
  "glasses.noProducts": string;
  "glasses.noFilterMatch": string;
  "glasses.loadMore": string;
  "glasses.buyTitle": string;
  "glasses.buyText": string;
  "glasses.buyCtaBook": string;
  "glasses.buyCtaStores": string;
  "glasses.pricesTitle": string;
  "glasses.pricesTeaser": string;
  "glasses.pricesLink": string;
  "glasses.faqTitle": string;
  "glasses.faq1Q": string;
  "glasses.faq1A": string;
  "glasses.faq2Q": string;
  "glasses.faq2A": string;
  "glasses.faq3Q": string;
  "glasses.faq3A": string;
  "glasses.faq4Q": string;
  "glasses.faq4A": string;
  "glasses.faq5Q": string;
  "glasses.faq5A": string;
  "glasses.faq6Q": string;
  "glasses.faq6A": string;
  "glasses.faq7Q": string;
  "glasses.faq7A": string;
  // Product page
  "product.inStockAt": string;
  "product.availableInStore": string;
  "product.trustMobileMoney": string;
  "product.trustPickup": string;
  "product.trustEyeTest": string;
  "product.lensType": string;
  "product.lensFrameOnly": string;
  "product.lensSimple": string;
  "product.lensPhotochromic": string;
  "product.prescriptionTitle": string;
  "product.prescriptionYes": string;
  "product.prescriptionNo": string;
  "product.prescriptionBookCta": string;
  "product.pickupTitle": string;
  "product.pickupSelect": string;
  "product.addToCart": string;
  "product.outOfStock": string;
  "product.whyTitle": string;
  "product.whyMobileMoney": string;
  "product.whyPickup": string;
  "product.whyWhatsApp": string;
  "product.whyAdjustment": string;
  "product.whyNetwork": string;
  "product.detailsTitle": string;
  "product.availabilityTitle": string;
  "product.seeStoresIn": string;
  "product.howTitle": string;
  "product.howStep1": string;
  "product.howStep2": string;
  "product.howStep3": string;
  "product.howPricesLink": string;
  "product.faqTitle": string;
  "product.faq1Q": string;
  "product.faq1A": string;
  "product.faq2Q": string;
  "product.faq2A": string;
  "product.faq3Q": string;
  "product.faq3A": string;
  "product.faq4Q": string;
  "product.faq4A": string;
  "product.faq5Q": string;
  "product.faq5A": string;
  "product.backToGlasses": string;
  "product.bookEyeTest": string;
  "product.step": string;
};

const fr: TranslationKeys = {
  "nav.book": "Test de vue GRATUIT",
  "nav.findStore": "Trouver une agence",
  "nav.eyeTest": "Test de vue",
  "nav.stores": "Agences",
  "nav.glasses": "Lunettes",
  "nav.prices": "Prix",
  "nav.howItWorks": "Comment ça marche",
  "nav.help": "Aide",
  "nav.whatsapp": "WhatsApp",
  "nav.careers": "Carrières",
  "hero.title": "Des lunettes de qualité à prix accessible",
  "hero.subtitle": "Test de vue gratuit dans nos 120+ agences en Afrique",
  "hero.cta": "Réserver un test de vue GRATUIT",
  "hero.ctaSecondary": "Voir les montures",
  "packages.title": "Nos forfaits",
  "packages.from": "À partir de",
  "store.nearest": "Agence le plus proche",
  "store.findStore": "Trouver une agence",
  "store.openingHours": "Horaires d'ouverture",
  "trust.countries": "10 pays",
  "trust.branches": "120+ agences",
  "trust.freeTest": "Test de vue gratuit",
  "booking.title": "Réserver un test de vue gratuit",
  "booking.selectBranch": "Choisir une ville :",
  "booking.selectBranchSingle": "Choisir une agence",
  "booking.selectDate": "Choisir une date",
  "booking.selectTime": "Choisir une heure",
  "booking.yourName": "Votre nom",
  "booking.yourPhone": "Votre numéro WhatsApp",
  "booking.confirm": "Confirmer le rendez-vous",
  "booking.confirmed": "Rendez-vous confirmé !",
  "booking.confirmedMsg": "Nous vous attendons. Pensez à apporter votre ordonnance si vous en avez une.",
  "booking.bringPrescription": "Apportez votre ordonnance",
  "booking.sendWhatsApp": "Envoyer l'ordonnance via WhatsApp",
  "city.eyeTest": "Test de vue gratuit à",
  "city.branches": "Nos agences à",
  "city.faq": "Questions fréquentes",
  "city.heroTitle": "Opticien à {city} – Test de vue gratuit chez Lapaire",
  "city.heroSubtitle": "Retrouvez nos agences Lapaire à {city}. Prenez rendez-vous pour un test de vue gratuit dans votre quartier.",
  "city.heroPill": "Votre opticien proche de chez vous à {city}",
  "city.heroFreeNote": "100% gratuit · Sans engagement · 20 min",
  "city.heroCta": "Réserver mon test de vue GRATUIT",
  "city.heroCtaSecondary": "Voir nos agences à {city}",
  "city.branchesTitle": "Nos agences Lapaire à {city}",
  "city.branchBook": "Prendre rendez-vous ici",
  "city.branchMap": "Itinéraire",
  "city.branchHours": "Horaires d'ouverture",
  "city.contextTitle": "Pourquoi choisir Lapaire à {city} ?",
  "city.contextP1": "À {city}, Lapaire vous accueille dans des agences accessibles, situées dans les quartiers les plus fréquentés. Nos opticiens qualifiés réalisent un test de vue gratuit et vous accompagnent dans le choix de vos lunettes.",
  "city.contextP2": "Que vous recherchiez des lunettes de vue, des lunettes de soleil ou des lunettes anti-lumière bleue, nos agences à {city} proposent un large choix de montures à prix accessibles.",
  "city.contextP3": "Lapaire s'adapte aux besoins locaux à {city}, {country} : nouvelles montures stylées chaque semaine, retrait en agence rapide et service client disponible par WhatsApp.",
  "city.eyeTestTitle": "Test de vue gratuit à {city}",
  "city.eyeTestDesc": "Nos opticiens à {city} réalisent un examen de la vue complet, gratuit et sans engagement. Le test de vue dure environ 20 minutes et permet de déterminer votre correction visuelle.",
  "city.eyeTestDuration": "Durée : environ 20 minutes",
  "city.eyeTestBring": "Apportez votre ordonnance si vous en avez une",
  "city.eyeTestCta": "Réserver un test de vue gratuit à {city}",
  "city.eyeTestStep1Title": "Prise de rendez-vous en ligne",
  "city.eyeTestStep2Title": "Test de vue gratuit en agence",
  "city.eyeTestStep3Title": "Essayage de monture personnalisée",
  "city.glassesTitle": "Quelles lunettes trouver à {city} ?",
  "city.glassesDesc": "Nos agences à {city} proposent des lunettes de vue, lunettes de soleil et lunettes anti-lumière bleue. Toutes les montures sont disponibles avec verres correcteurs. Retrait en agence à {city} sous 24 à 72h.",
  "city.glassesCta": "Voir toutes les lunettes {prep} {country}",
  "city.pricesTitle": "Prix des lunettes à {city}",
  "city.pricesDesc": "Les lunettes Lapaire à {city} commencent à partir de {price}, monture et verres correcteurs inclus. Nouvelles montures chaque semaine dans toutes nos agences à {city}.",
  "city.pricesCta": "Voir tous les prix {prep} {country}",
  "city.faq1Q": "Où trouver un opticien à {city} ?",
  "city.faq1A": "Lapaire dispose de plusieurs agences à {city}. Consultez la liste ci-dessus pour trouver l'agence la plus proche de chez vous.",
  "city.faq2Q": "Le test de vue est-il gratuit à {city} ?",
  "city.faq2A": "Oui, le test de vue chez Lapaire est entièrement gratuit dans toutes nos agences à {city}. Aucun engagement requis.",
  "city.faq3Q": "Combien coûtent les lunettes Lapaire à {city} ?",
  "city.faq3A": "Les lunettes Lapaire à {city} commencent à partir de {price}, monture et verres correcteurs inclus.",
  "city.faq4Q": "Y a-t-il de nouvelles montures régulièrement à {city} ?",
  "city.faq4A": "Oui, de nouvelles montures stylées arrivent chaque semaine dans nos agences à {city}.",
  "city.faq5Q": "Combien de temps pour recevoir ses lunettes à {city} ?",
  "city.faq5A": "Vos lunettes sont généralement prêtes sous 24 à 72 heures dans nos agences à {city}.",
  "city.faq6Q": "Faut-il une ordonnance pour acheter des lunettes à {city} ?",
  "city.faq6A": "Non, nous réalisons un test de vue gratuit en agence à {city}. Si vous avez déjà une ordonnance, apportez-la lors de votre visite.",
  // Global homepage
  "global.heroTitle": "Lapaire – Lunettes abordables & test de vue gratuit en Afrique",
  "global.heroSubtitle": "Présent dans 10 pays et 134 agences. Test de vue gratuit, prix transparents, nouvelles montures chaque semaine.",
  "global.ctaCountry": "Choisir mon pays",
  "global.ctaBook": "Prendre un rendez-vous",
  "global.chooseCountry": "Choisissez votre pays",
  "global.bannerPrefix": "Il semble que vous êtes",
  "global.bannerAccept": "Accéder au site →",
  "global.trustTitle": "Un réseau d'opticiens de confiance en Afrique",
  "global.trustCountries": "10 pays",
  "global.trustBranches": "134 agences",
  "global.trustFreeTest": "Test de vue gratuit",
  "global.trustMobileMoney": "Nouvelles montures chaque semaine",
  "global.servicesTitle": "Nos services",
  "global.serviceEyeTestTitle": "Test de vue gratuit",
  "global.serviceEyeTestDesc": "Prenez rendez-vous dans l'une de nos agences pour un examen de la vue complet et gratuit.",
  "global.serviceEyeTestCta": "Prendre rendez-vous",
  "global.serviceGlassesTitle": "Lunettes à prix accessibles",
  "global.serviceGlassesDesc": "Découvrez nos collections homme, femme et soleil. Monture et verres correcteurs inclus.",
  "global.serviceGlassesCta": "Voir les lunettes",
  "global.serviceStoresTitle": "Trouver une agence",
  "global.serviceStoresDesc": "Localisez l'agence Lapaire la plus proche de chez vous.",
  "global.serviceStoresCta": "Voir les agences",
  "global.glassesTitle": "Nos lunettes",
  "global.glassesDesc": "Les lunettes Lapaire sont disponibles dans tous nos pays avec des prix adaptés localement. Lunettes de vue, lunettes de soleil et lunettes anti-lumière bleue.",
  "global.glassesCtaPrimary": "Voir les lunettes",
  "global.glassesCtaSecondary": "Voir les prix",
  "global.howTitle": "Comment ça marche",
  "global.howStep1Title": "Prenez rendez-vous",
  "global.howStep1Desc": "Réservez un créneau en ligne ou rendez-vous directement en agence.",
  "global.howStep2Title": "Faites votre test gratuit",
  "global.howStep2Desc": "Nos opticiens qualifiés réalisent un examen complet de la vue en 20 minutes.",
  "global.howStep3Title": "Choisissez vos lunettes",
  "global.howStep3Desc": "Sélectionnez votre monture et repartez avec vos lunettes sous 24 à 72h.",
  "global.faqTitle": "Questions fréquentes",
  "global.faq1Q": "Où trouver Lapaire ?",
  "global.faq1A": "Lapaire est présent dans 10 pays en Afrique avec plus de 120 [agences](/{slug}/stores) : Mali, Bénin, Burkina Faso, Cameroun, Côte d'Ivoire, Togo, Ouganda, Maroc, Sénégal et République démocratique du Congo.",
  "global.faq2Q": "Le test de vue est-il gratuit ?",
  "global.faq2A": "Oui, le test de vue est entièrement gratuit et sans engagement dans toutes nos [agences](/{slug}/stores) Lapaire. [Prenez rendez-vous en ligne](/{slug}/book) en quelques clics.",
  "global.faq3Q": "Dans quels pays Lapaire est-il présent ?",
  "global.faq3A": "Lapaire est présent au Mali, Bénin, Burkina Faso, Cameroun, Côte d'Ivoire, Togo, Ouganda, Maroc, Sénégal et en République démocratique du Congo. [Choisissez votre pays](/) pour voir les agences proches.",
  "global.faq4Q": "Y a-t-il de nouvelles montures régulièrement ?",
  "global.faq4A": "Oui, de nouvelles montures stylées arrivent chaque semaine. [Découvrez le catalogue](/{slug}/glasses) mis à jour en temps réel.",
  "global.faq5Q": "Combien coûtent les lunettes Lapaire ?",
  "global.faq5A": "Nos forfaits incluent monture et verres correcteurs à des prix accessibles. Consultez la [page des prix](/{slug}/prices) pour les tarifs en devise locale ou parcourez les [lunettes disponibles](/{slug}/glasses).",
  "global.about": "À propos",
  "global.footerRights": "Tous droits réservés.",
  "global.bookRdv": "Prendre RDV",
  "general.learnMore": "En savoir plus",
  "general.whatsapp": "WhatsApp",
  "general.call": "Appeler",
  "general.country": "Pays",
  // Country page SEO
  "country.heroTitle": "Opticien {prep} {country} – Test de vue gratuit & lunettes abordables",
  "country.heroSubtitle": "Prenez rendez-vous dans l'une de nos {branches} agences {prep} {country}. Test de vue gratuit, prix transparents, nouvelles montures chaque semaine.",
  "country.heroPill": "Votre opticien {prep} {country}",
  "country.heroFreeNote": "100% gratuit · Sans engagement · 20 min",
  "country.proofIntro": "Lapaire est l'un des principaux opticiens {prep} {country}, avec {cities} villes couvertes et {branches} agences.",
  "country.proofPriceFrom": "Nos lunettes {prep} {country} sont disponibles à partir de {price}.",
  "country.proofMobileMoney": "Nouvelles montures chaque semaine",
  "country.citiesTitle": "Nos agences {prep} {country}",
  "country.cityMicroDesc": "Opticien à {city} – test de vue gratuit et lunettes à prix accessibles.",
  "country.citySeeBranches": "Voir nos agences à {city}",
  "country.eyeTestTitle": "Test de vue gratuit {prep} {country}",
  "country.eyeTestDesc": "Nos opticiens qualifiés réalisent un examen de la vue complet en agence. Le contrôle de la vue est entièrement gratuit et sans engagement.",
  "country.eyeTestDuration": "Durée : environ 20 minutes",
  "country.eyeTestNoObligation": "Aucun engagement obligatoire après le test",
  "country.eyeTestCta": "Réserver un test de vue gratuit",
  "country.eyeTestHowItWorks": "Comment ça marche ?",
  "country.glassesTitle": "Lunettes {prep} {country}",
  "country.glassesDesc": "Découvrez notre collection de lunettes homme et femme {prep} {country}. Lunettes de vue, lunettes de soleil et lunettes anti-lumière bleue à prix accessibles. Toutes nos montures sont disponibles avec verres correcteurs.",
  "country.glassesCta": "Voir toutes les lunettes",
  "country.pricesTitle": "Prix des lunettes {prep} {country}",
  "country.pricesPackage": "Forfait monture + verres correcteurs",
  "country.pricesFrom": "À partir de",
  "country.pricesCta": "Voir tous les prix {prep} {country}",
  "country.faqTitle": "Questions fréquentes",
  "country.faq1Q": "Combien coûte un test de vue {prep} {country} ?",
  "country.faq1A": "Le test de vue chez Lapaire est entièrement gratuit dans toutes nos agences {prep} {country}. Aucun engagement requis.",
  "country.faq2Q": "Où trouver un opticien {prep} {country} ?",
  "country.faq2A": "Lapaire dispose de {branches} agences dans {cities} villes {prep} {country}. Trouvez l'agence la plus proche de chez vous.",
  "country.faq2AOne": "Lapaire dispose de {branches} agence {prep} {country}. Retrouvez-la ci-dessus.",
  "country.faq3Q": "Quel est le prix des lunettes {prep} {country} ?",
  "country.faq3A": "Les lunettes Lapaire {prep} {country} commencent à partir de {price}, monture et verres correcteurs inclus.",
  "country.faq4Q": "Y a-t-il de nouvelles montures régulièrement ?",
  "country.faq4A": "Oui, de nouvelles montures stylées arrivent chaque semaine dans nos agences {prep} {country}.",
  "country.faq5Q": "Faut-il une ordonnance pour acheter des lunettes ?",
  "country.faq5A": "Non, nous réalisons un test de vue gratuit en agence. Si vous avez déjà une ordonnance, apportez-la lors de votre visite.",
  "country.faq6Q": "Combien de temps pour recevoir ses lunettes ?",
  "country.faq6A": "Vos lunettes sont généralement prêtes sous 24 à 72 heures selon la correction nécessaire.",
  "country.citiesCount": "{count} villes dans le pays",
  "country.citiesCountOne": "1 ville dans le pays",
  "country.branchesCount": "{count} agences à disposition",
  "country.branchesCountOne": "1 agence à disposition",
  "country.proofIntroOne": "Lapaire est l'un des principaux opticiens {prep} {country}, avec 1 ville couverte et {branches} agence.",
  "country.proofFrameFrom": "Nos montures {prep} {country} sont disponibles à partir de {framePrice}.",
  "country.proofPackFrom": "Nos forfaits monture + verres correcteurs démarrent à {packPrice}.",
  "country.whyTitle": "Pourquoi choisir Lapaire {prep} {country}",
  "country.whySubtitle": "L'opticien de confiance panafricain, pensé pour votre quotidien.",
  "country.whyPillar1Title": "Test de vue gratuit",
  "country.whyPillar1Desc": "Un examen complet réalisé par un opticien qualifié en agence, sans engagement.",
  "country.whyPillar2Title": "Prix transparents",
  "country.whyPillar2Desc": "Forfait monture + verres correcteurs affiché clairement, sans mauvaise surprise à la caisse.",
  "country.whyPillar3Title": "Réseau proche de chez vous",
  "country.whyPillar3Desc": "Nos agences sont ouvertes 6 jours sur 7 pour vous accueillir, essayer et repartir équipé.",
  "country.whyPillar4Title": "Garantie et suivi",
  "country.whyPillar4Desc": "Ajustements gratuits en agence et service après-vente accessible sur WhatsApp.",
  "country.journeyTitle": "Comment ça marche",
  "country.journeySubtitle": "Quatre étapes simples, de la prise de rendez-vous à la remise de vos lunettes.",
  "country.journey1Title": "Réservez en ligne",
  "country.journey1Desc": "Choisissez votre agence, un jour et une heure. Aucun compte requis.",
  "country.journey2Title": "Test de vue en agence",
  "country.journey2Desc": "Un opticien vérifie votre vue en 20 minutes, gratuitement.",
  "country.journey3Title": "Choisissez votre monture",
  "country.journey3Desc": "Essayez nos montures en agence ou sélectionnez-en une en ligne, puis ajoutez vos verres.",
  "country.journey4Title": "Recevez vos lunettes",
  "country.journey4Desc": "Vos lunettes sont prêtes en 24 à 72 h. Retrait en agence ou livraison locale.",
  // Glasses page
  "glasses.heroTitle": "Lunettes {prep} {country} – Choisissez votre monture",
  "glasses.heroSubtitle": "Montures disponibles en {currency}. Nouvelles montures chaque semaine. Retrait en agence.",
  "glasses.heroCta": "Voir les montures disponibles",
  "glasses.heroCtaSecondary": "Voir les prix",
  "glasses.filterAll": "Tout",
  "glasses.filterWomen": "Femme",
  "glasses.filterMen": "Homme",
  "glasses.filterSun": "Soleil",
  "glasses.filterRimless": "Sans monture",
  "glasses.filterNew": "Nouveautés",
  "glasses.wizardQ1": "Genre",
  "glasses.wizardQ2": "Forme",
  "glasses.wizardQ3": "Matière",
  "glasses.wizardQ4": "Couleur",
  "glasses.wizardAll": "Tous",
  "glasses.wizardMen": "Homme",
  "glasses.wizardWomen": "Femme",
  "glasses.wizardOptical": "Optique",
  "glasses.wizardSun": "Soleil",
  "glasses.wizardRimless": "Sans monture",
  "glasses.wizardRound": "Ronde",
  "glasses.wizardRectangle": "Rectangulaire",
  "glasses.wizardAviator": "Aviateur",
  "glasses.wizardCatEye": "Papillon",
  "glasses.wizardReset": "Réinitialiser",
  "glasses.productChoose": "Choisir cette monture",
  "glasses.inStock": "En stock",
  "glasses.noProducts": "Aucun produit disponible pour le moment.",
  "glasses.noFilterMatch": "Aucune monture ne correspond à cette sélection. Voici toutes nos montures disponibles.",
  "glasses.loadMore": "Voir plus de montures",
  "glasses.buyTitle": "Choisissez vos lunettes en ligne, essayez-les {prep} {country}",
  "glasses.buyText": "Découvrez nos nouvelles montures en ligne et réservez gratuitement un essayage dans l'agence Lapaire la plus proche.",
  "glasses.buyCtaBook": "Prendre rendez-vous test de vue",
  "glasses.buyCtaStores": "Trouver une agence",
  "glasses.pricesTitle": "Prix des lunettes {prep} {country}",
  "glasses.pricesTeaser": "Nos lunettes {prep} {country} commencent à partir de {price}, monture et verres correcteurs inclus. Nouvelles montures chaque semaine.",
  "glasses.pricesLink": "Voir tous les prix {prep} {country}",
  "glasses.faqTitle": "Questions fréquentes sur l'achat de lunettes {prep} {country}",
  "glasses.faq1Q": "Quel est le prix des lunettes {prep} {country} ?",
  "glasses.faq1A": "Les lunettes Lapaire {prep} {country} commencent à partir de {price}, monture et verres correcteurs inclus.",
  "glasses.faq2Q": "Y a-t-il de nouvelles montures chaque semaine ?",
  "glasses.faq2A": "Oui, de nouvelles montures stylées arrivent chaque semaine dans nos agences {prep} {country}.",
  "glasses.faq3Q": "Puis-je retirer mes lunettes en agence ?",
  "glasses.faq3A": "Oui, vos lunettes sont prêtes sous 24 à 72h et récupérables dans l'agence Lapaire de votre choix.",
  "glasses.faq4Q": "Comment choisir la bonne monture ?",
  "glasses.faq4A": "Parcourez notre catalogue en ligne ou rendez-vous en agence pour essayer les montures. Nos opticiens vous guident gratuitement.",
  "glasses.faq5Q": "Les montures affichées sont-elles disponibles {prep} {country} ?",
  "glasses.faq5A": "Oui, seules les montures disponibles {prep} {country} sont affichées sur cette page.",
  "glasses.faq6Q": "Faut-il une ordonnance pour acheter des lunettes ?",
  "glasses.faq6A": "Non, nous réalisons un test de vue gratuit en agence. Si vous avez déjà une ordonnance, apportez-la.",
  "glasses.faq7Q": "Comment faire si je veux un test de vue ?",
  "glasses.faq7A": "Réservez un créneau gratuit en ligne ou rendez-vous directement dans l'une de nos agences {prep} {country}.",
  // Product page
  "product.inStockAt": "En stock {prep} {country}",
  "product.availableInStore": "Disponible en agence",
  "product.trustMobileMoney": "Nouveautés chaque semaine",
  "product.trustPickup": "Retrait en agence",
  "product.trustEyeTest": "Test de vue gratuit disponible",
  "product.lensType": "Type de verres",
  "product.lensFrameOnly": "Monture seule",
  "product.lensSimple": "Verres simples",
  "product.lensPhotochromic": "Verres photochromiques",
  "product.prescriptionTitle": "Avez-vous une ordonnance ?",
  "product.prescriptionYes": "Oui, j'ai une ordonnance",
  "product.prescriptionNo": "Non, je veux un test de vue gratuit",
  "product.prescriptionBookCta": "Prendre rendez-vous en agence",
  "product.pickupTitle": "Agence de retrait",
  "product.pickupSelect": "Choisir une agence…",
  "product.addToCart": "Ajouter au panier",
  "product.outOfStock": "Rupture de stock",
  "product.whyTitle": "Pourquoi choisir cette monture chez Lapaire ?",
  "product.whyMobileMoney": "Nouvelles montures stylées chaque semaine",
  "product.whyPickup": "Retrait dans votre agence locale",
  "product.whyWhatsApp": "Assistance par WhatsApp",
  "product.whyAdjustment": "Ajustement gratuit en agence",
  "product.whyNetwork": "Réseau de 120+ agences en Afrique",
  "product.detailsTitle": "Détails de la monture",
  "product.availabilityTitle": "Disponible dans nos agences {prep} {country}",
  "product.seeStoresIn": "Voir nos agences à {city}",
  "product.howTitle": "Comment ça marche",
  "product.howStep1": "Choisissez votre monture en ligne",
  "product.howStep2": "Ajoutez vos verres et votre ordonnance",
  "product.howStep3": "Récupérez vos lunettes en agence",
  "product.howPricesLink": "Voir tous les prix {prep} {country}",
  "product.faqTitle": "Questions fréquentes",
  "product.faq1Q": "Cette monture est-elle disponible {prep} {country} ?",
  "product.faq1A": "Oui, toutes les montures affichées sont disponibles {prep} {country}. Vous pouvez la récupérer dans l'une de nos agences.",
  "product.faq2Q": "Avez-vous régulièrement de nouvelles montures ?",
  "product.faq2A": "Oui, de nouvelles montures stylées arrivent chaque semaine dans toutes les agences Lapaire.",
  "product.faq3Q": "Combien de temps pour récupérer mes lunettes ?",
  "product.faq3A": "Vos lunettes sont généralement prêtes sous 24 à 72 heures selon la correction nécessaire.",
  "product.faq4Q": "Puis-je faire un test de vue en agence ?",
  "product.faq4A": "Oui, le test de vue chez Lapaire est entièrement gratuit et sans engagement.",
  "product.faq5Q": "Puis-je envoyer mon ordonnance via WhatsApp ?",
  "product.faq5A": "Oui, vous pouvez envoyer votre ordonnance directement via WhatsApp à notre équipe.",
  "product.backToGlasses": "Retour aux lunettes",
  "product.bookEyeTest": "Prendre un test de vue gratuit",
  "product.step": "Étape {n}",
};

const en: TranslationKeys = {
  "nav.book": "FREE Eye Test",
  "nav.findStore": "Find a Branch",
  "nav.eyeTest": "Eye Test",
  "nav.stores": "Branches",
  "nav.glasses": "Glasses",
  "nav.prices": "Prices",
  "nav.howItWorks": "How it Works",
  "nav.help": "Help",
  "nav.whatsapp": "WhatsApp",
  "nav.careers": "Careers",
  "hero.title": "Quality glasses at affordable prices",
  "hero.subtitle": "Free eye test in our 120+ branches across Africa",
  "hero.cta": "Book FREE Eye Test",
  "hero.ctaSecondary": "Browse Frames",
  "packages.title": "Our Packages",
  "packages.from": "Starting from",
  "store.nearest": "Nearest Branch",
  "store.findStore": "Find a Branch",
  "store.openingHours": "Opening Hours",
  "trust.countries": "10 countries",
  "trust.branches": "120+ branches",
  "trust.freeTest": "Free eye test",
  "booking.title": "Book a free eye test",
  "booking.selectBranch": "Choose a city:",
  "booking.selectBranchSingle": "Choose a store",
  "booking.selectDate": "Select a date",
  "booking.selectTime": "Select a time",
  "booking.yourName": "Your name",
  "booking.yourPhone": "Your WhatsApp number",
  "booking.confirm": "Confirm appointment",
  "booking.confirmed": "Appointment confirmed!",
  "booking.confirmedMsg": "We look forward to seeing you. Please bring your prescription if you have one.",
  "booking.bringPrescription": "Bring your prescription",
  "booking.sendWhatsApp": "Send prescription via WhatsApp",
  "city.eyeTest": "Free eye test in",
  "city.branches": "Our branches in",
  "city.faq": "Frequently Asked Questions",
  "city.heroTitle": "Optician in {city} – Free eye test at Lapaire",
  "city.heroSubtitle": "Find our Lapaire branches in {city}. Book your free eye test in your neighbourhood.",
  "city.heroPill": "Your optician near you in {city}",
  "city.heroFreeNote": "100% free · No commitment · 20 min",
  "city.heroCta": "Book my FREE eye test",
  "city.heroCtaSecondary": "See our branches in {city}",
  "city.branchesTitle": "Lapaire branches in {city}",
  "city.branchBook": "Book here",
  "city.branchMap": "Directions",
  "city.branchHours": "Opening hours",
  "city.contextTitle": "Why choose Lapaire in {city}?",
  "city.contextP1": "In {city}, Lapaire welcomes you in accessible branches located in the busiest neighbourhoods. Our qualified opticians perform a free eye test and guide you in choosing your glasses.",
  "city.contextP2": "Whether you're looking for prescription glasses, sunglasses or blue-light blocking glasses, our branches in {city} offer a wide range of frames at affordable prices.",
  "city.contextP3": "Lapaire adapts to local needs in {city}, {country}: new stylish frames every week, fast in-branch pickup and customer service available via WhatsApp.",
  "city.eyeTestTitle": "Free eye test in {city}",
  "city.eyeTestDesc": "Our opticians in {city} perform a comprehensive, free eye examination with no obligation. The eye test takes about 20 minutes and determines your visual correction.",
  "city.eyeTestDuration": "Duration: approximately 20 minutes",
  "city.eyeTestBring": "Bring your prescription if you have one",
  "city.eyeTestCta": "Book a free eye test in {city}",
  "city.eyeTestStep1Title": "Online booking",
  "city.eyeTestStep2Title": "Free eye test in branch",
  "city.eyeTestStep3Title": "Personal frame fitting",
  "city.glassesTitle": "What glasses to find in {city}?",
  "city.glassesDesc": "Our branches in {city} offer prescription glasses, sunglasses and blue-light blocking glasses. All frames are available with corrective lenses. In-branch pickup in {city} within 24 to 72 hours.",
  "city.glassesCta": "See all glasses in {country}",
  "city.pricesTitle": "Glasses prices in {city}",
  "city.pricesDesc": "Lapaire glasses in {city} start from {price}, frame and corrective lenses included. new styles every week in all our branches in {city}.",
  "city.pricesCta": "See all prices in {country}",
  "city.faq1Q": "Where to find an optician in {city}?",
  "city.faq1A": "Lapaire has several branches in {city}. Check the list above to find the nearest branch to you.",
  "city.faq2Q": "Is the eye test free in {city}?",
  "city.faq2A": "Yes, the eye test at Lapaire is completely free in all our branches in {city}. No obligation required.",
  "city.faq3Q": "How much do Lapaire glasses cost in {city}?",
  "city.faq3A": "Lapaire glasses in {city} start from {price}, frame and corrective lenses included.",
  "city.faq4Q": "Do you get new frames regularly in {city}?",
  "city.faq4A": "Yes, new stylish frames arrive every week in our {city} stores.",
  "city.faq5Q": "How long to receive my glasses in {city}?",
  "city.faq5A": "Your glasses are usually ready within 24 to 72 hours in our branches in {city}.",
  "city.faq6Q": "Do I need a prescription to buy glasses in {city}?",
  "city.faq6A": "No, we perform a free eye test in branch in {city}. If you already have a prescription, bring it with you.",
  // Global homepage
  "global.heroTitle": "Lapaire – Affordable glasses & free eye test in Africa",
  "global.heroSubtitle": "Present in 10 countries with 134 branches. Free eye test, transparent prices, new styles every week.",
  "global.ctaCountry": "Choose my country",
  "global.ctaBook": "Book an appointment",
  "global.chooseCountry": "Choose your country",
  "global.bannerPrefix": "It looks like you are in",
  "global.bannerAccept": "Go to site →",
  "global.trustTitle": "A trusted network of opticians in Africa",
  "global.trustCountries": "10 countries",
  "global.trustBranches": "134 branches",
  "global.trustFreeTest": "Free eye test",
  "global.trustMobileMoney": "New styles every week",
  "global.servicesTitle": "Our services",
  "global.serviceEyeTestTitle": "Free eye test",
  "global.serviceEyeTestDesc": "Book an appointment at one of our branches for a free comprehensive eye examination.",
  "global.serviceEyeTestCta": "Book an appointment",
  "global.serviceGlassesTitle": "Affordable glasses",
  "global.serviceGlassesDesc": "Discover our men's, women's and sun collections. Frame and corrective lenses included.",
  "global.serviceGlassesCta": "See glasses",
  "global.serviceStoresTitle": "Find a branch",
  "global.serviceStoresDesc": "Find the nearest Lapaire branch to you.",
  "global.serviceStoresCta": "See branches",
  "global.glassesTitle": "Our glasses",
  "global.glassesDesc": "Lapaire glasses are available in all our countries with locally adapted prices. Prescription glasses, sunglasses and blue-light blocking glasses.",
  "global.glassesCtaPrimary": "See glasses",
  "global.glassesCtaSecondary": "See prices",
  "global.howTitle": "How it works",
  "global.howStep1Title": "Book an appointment",
  "global.howStep1Desc": "Reserve a slot online or walk in to any branch.",
  "global.howStep2Title": "Get your free test",
  "global.howStep2Desc": "Our qualified opticians perform a full eye examination in 20 minutes.",
  "global.howStep3Title": "Choose your glasses",
  "global.howStep3Desc": "Select your frame and get your glasses within 24 to 72 hours.",
  "global.faqTitle": "Frequently asked questions",
  "global.faq1Q": "Where to find Lapaire?",
  "global.faq1A": "Lapaire operates in 10 African countries with over 120 [branches](/{slug}/stores): Mali, Benin, Burkina Faso, Cameroon, Côte d'Ivoire, Togo, Uganda, Morocco, Senegal and the Democratic Republic of the Congo.",
  "global.faq2Q": "Is the eye test free?",
  "global.faq2A": "Yes, the eye test is completely free with no obligation in all Lapaire [branches](/{slug}/stores). [Book online](/{slug}/book) in just a few clicks.",
  "global.faq3Q": "In which countries is Lapaire present?",
  "global.faq3A": "Lapaire is present in Mali, Benin, Burkina Faso, Côte d'Ivoire, Togo, Uganda, Morocco, Senegal and the Democratic Republic of the Congo. [Pick your country](/) to see nearby branches.",
  "global.faq4Q": "Do you get new frames regularly?",
  "global.faq4A": "Yes, new stylish frames arrive every week. [Browse the catalogue](/{slug}/glasses) updated in real time.",
  "global.faq5Q": "How much do Lapaire glasses cost?",
  "global.faq5A": "Our packages include frame and corrective lenses at affordable prices. Check the [pricing page](/{slug}/prices) for local currency rates or browse [available glasses](/{slug}/glasses).",
  "global.about": "About",
  "global.footerRights": "All rights reserved.",
  "global.bookRdv": "Book Appointment",
  "general.learnMore": "Learn more",
  "general.whatsapp": "WhatsApp",
  "general.call": "Call",
  "general.country": "Country",
  // Country page SEO
  "country.heroTitle": "Optician in {country} – Free eye test & affordable glasses",
  "country.heroSubtitle": "Book an appointment at one of our {branches} branches in {country}. Free eye test, transparent prices, new styles every week.",
  "country.heroPill": "Your optician in {country}",
  "country.heroFreeNote": "100% free · No commitment · 20 min",
  "country.proofIntro": "Lapaire is a leading optician in {country}, with {cities} cities covered and {branches} branches.",
  "country.proofPriceFrom": "Our glasses in {country} start from {price}.",
  "country.proofMobileMoney": "New styles every week",
  "country.citiesTitle": "Our branches in {country}",
  "country.cityMicroDesc": "Optician in {city} – free eye test and affordable glasses.",
  "country.citySeeBranches": "See our branches in {city}",
  "country.eyeTestTitle": "Free eye test in {country}",
  "country.eyeTestDesc": "Our qualified opticians perform a comprehensive eye examination in branch. The eye test is completely free with no obligation.",
  "country.eyeTestDuration": "Duration: approximately 20 minutes",
  "country.eyeTestNoObligation": "No obligation after the test",
  "country.eyeTestCta": "Book a free eye test",
  "country.eyeTestHowItWorks": "How does it work?",
  "country.glassesTitle": "Glasses in {country}",
  "country.glassesDesc": "Discover our collection of men's and women's glasses in {country}. Prescription glasses, sunglasses and blue-light blocking glasses at affordable prices. All frames available with corrective lenses.",
  "country.glassesCta": "See all glasses",
  "country.pricesTitle": "Glasses prices in {country}",
  "country.pricesPackage": "Frame + prescription lens package",
  "country.pricesFrom": "Starting from",
  "country.pricesCta": "See all prices in {country}",
  "country.faqTitle": "Frequently Asked Questions",
  "country.faq1Q": "How much does an eye test cost in {country}?",
  "country.faq1A": "The eye test at Lapaire is completely free in all our branches in {country}. No obligation required.",
  "country.faq2Q": "Where to find an optician in {country}?",
  "country.faq2A": "Lapaire has {branches} branches in {cities} cities across {country}. Find the nearest branch to you.",
  "country.faq2AOne": "Lapaire has {branches} branch in {country}. Details are listed above.",
  "country.faq3Q": "What is the price of glasses in {country}?",
  "country.faq3A": "Lapaire glasses in {country} start from {price}, frame and corrective lenses included.",
  "country.faq4Q": "Do you get new frames regularly?",
  "country.faq4A": "Yes, new stylish frames arrive every week in our stores in {country}.",
  "country.faq5Q": "Do I need a prescription to buy glasses?",
  "country.faq5A": "No, we perform a free eye test in branch. If you already have a prescription, bring it with you.",
  "country.faq6Q": "How long to receive my glasses?",
  "country.faq6A": "Your glasses are usually ready within 24 to 72 hours depending on the correction needed.",
  "country.citiesCount": "{count} cities in the country",
  "country.citiesCountOne": "1 city in the country",
  "country.branchesCount": "{count} branches available",
  "country.branchesCountOne": "1 branch available",
  "country.proofIntroOne": "Lapaire is a leading optician in {country}, with 1 city covered and {branches} branch.",
  "country.proofFrameFrom": "Our frames in {country} start from {framePrice}.",
  "country.proofPackFrom": "Our frame + prescription lens packages start at {packPrice}.",
  "country.whyTitle": "Why choose Lapaire in {country}",
  "country.whySubtitle": "A trusted pan-African optician, designed for your daily life.",
  "country.whyPillar1Title": "Free eye test",
  "country.whyPillar1Desc": "A complete exam by a qualified optician in branch, with no obligation.",
  "country.whyPillar2Title": "Transparent prices",
  "country.whyPillar2Desc": "Frame + prescription lens packages shown up front — no surprises at checkout.",
  "country.whyPillar3Title": "A branch near you",
  "country.whyPillar3Desc": "Our stores are open 6 days a week to welcome you, fit your frames and get you set up.",
  "country.whyPillar4Title": "Warranty and support",
  "country.whyPillar4Desc": "Free adjustments in branch and after-sales support available on WhatsApp.",
  "country.journeyTitle": "How it works",
  "country.journeySubtitle": "Four simple steps, from booking your slot to picking up your glasses.",
  "country.journey1Title": "Book online",
  "country.journey1Desc": "Pick a branch, a day and a time. No account required.",
  "country.journey2Title": "Free eye test",
  "country.journey2Desc": "An optician checks your eyes in about 20 minutes, at no cost.",
  "country.journey3Title": "Choose your frame",
  "country.journey3Desc": "Try our frames in branch or pick one online, then add your lenses.",
  "country.journey4Title": "Get your glasses",
  "country.journey4Desc": "Your glasses are ready in 24 to 72 hours. Pick up in branch or local delivery.",
  // Glasses page
  "glasses.heroTitle": "Glasses in {country} – Choose your frame",
  "glasses.heroSubtitle": "Frames available in {currency}. new styles every week. In-branch pickup.",
  "glasses.heroCta": "Browse available frames",
  "glasses.heroCtaSecondary": "See prices",
  "glasses.filterAll": "All",
  "glasses.filterWomen": "Women",
  "glasses.filterMen": "Men",
  "glasses.filterSun": "Sunglasses",
  "glasses.filterRimless": "Rimless",
  "glasses.filterNew": "New",
  "glasses.wizardQ1": "Gender",
  "glasses.wizardQ2": "Shape",
  "glasses.wizardQ3": "Material",
  "glasses.wizardQ4": "Color",
  "glasses.wizardAll": "All",
  "glasses.wizardMen": "Men",
  "glasses.wizardWomen": "Women",
  "glasses.wizardOptical": "Optical",
  "glasses.wizardSun": "Sunglasses",
  "glasses.wizardRimless": "Rimless",
  "glasses.wizardRound": "Round",
  "glasses.wizardRectangle": "Rectangle",
  "glasses.wizardAviator": "Aviator",
  "glasses.wizardCatEye": "Cat-eye",
  "glasses.wizardReset": "Reset",
  "glasses.productChoose": "Choose this frame",
  "glasses.inStock": "In stock",
  "glasses.noProducts": "No products available at the moment.",
  "glasses.noFilterMatch": "No frames match this selection. Here are all our available frames.",
  "glasses.loadMore": "Load more frames",
  "glasses.buyTitle": "Pick your glasses online, try them on in {country}",
  "glasses.buyText": "Browse new frames online and book a free try-on at your nearest Lapaire store.",
  "glasses.buyCtaBook": "Book a free eye test",
  "glasses.buyCtaStores": "Find a branch",
  "glasses.pricesTitle": "Glasses prices in {country}",
  "glasses.pricesTeaser": "Our glasses in {country} start from {price}, frame and corrective lenses included. new styles every week.",
  "glasses.pricesLink": "See all prices in {country}",
  "glasses.faqTitle": "Frequently asked questions about buying glasses in {country}",
  "glasses.faq1Q": "What is the price of glasses in {country}?",
  "glasses.faq1A": "Lapaire glasses in {country} start from {price}, frame and corrective lenses included.",
  "glasses.faq2Q": "Do you add new frames every week?",
  "glasses.faq2A": "Yes, new stylish frames arrive every week in our stores in {country}.",
  "glasses.faq3Q": "Can I pick up my glasses in branch?",
  "glasses.faq3A": "Yes, your glasses are ready within 24 to 72 hours and can be collected at your chosen Lapaire branch.",
  "glasses.faq4Q": "How do I choose the right frame?",
  "glasses.faq4A": "Browse our online catalogue or visit a branch to try frames. Our opticians guide you for free.",
  "glasses.faq5Q": "Are the frames shown available in {country}?",
  "glasses.faq5A": "Yes, only frames available in {country} are displayed on this page.",
  "glasses.faq6Q": "Do I need a prescription to buy glasses?",
  "glasses.faq6A": "No, we perform a free eye test in branch. If you already have a prescription, bring it with you.",
  "glasses.faq7Q": "How do I get an eye test?",
  "glasses.faq7A": "Book a free slot online or visit one of our branches in {country} directly.",
  // Product page
  "product.inStockAt": "In stock in {country}",
  "product.availableInStore": "Available in branch",
  "product.trustMobileMoney": "New styles every week",
  "product.trustPickup": "In-branch pickup",
  "product.trustEyeTest": "Free eye test available",
  "product.lensType": "Lens type",
  "product.lensFrameOnly": "Frame only",
  "product.lensSimple": "Single vision lenses",
  "product.lensPhotochromic": "Photochromic lenses",
  "product.prescriptionTitle": "Do you have a prescription?",
  "product.prescriptionYes": "Yes, I have a prescription",
  "product.prescriptionNo": "No, I want a free eye test",
  "product.prescriptionBookCta": "Book an appointment in branch",
  "product.pickupTitle": "Pickup branch",
  "product.pickupSelect": "Choose a branch…",
  "product.addToCart": "Add to cart",
  "product.outOfStock": "Out of stock",
  "product.whyTitle": "Why choose this frame at Lapaire?",
  "product.whyMobileMoney": "New stylish frames every week",
  "product.whyPickup": "Pickup at your local branch",
  "product.whyWhatsApp": "WhatsApp support",
  "product.whyAdjustment": "Free adjustment in branch",
  "product.whyNetwork": "Network of 120+ branches across Africa",
  "product.detailsTitle": "Frame details",
  "product.availabilityTitle": "Available in our branches in {country}",
  "product.seeStoresIn": "See our branches in {city}",
  "product.howTitle": "How it works",
  "product.howStep1": "Choose your frame online",
  "product.howStep2": "Add your lenses and prescription",
  "product.howStep3": "Pick up your glasses in branch",
  "product.howPricesLink": "See all prices in {country}",
  "product.faqTitle": "Frequently asked questions",
  "product.faq1Q": "Is this frame available in {country}?",
  "product.faq1A": "Yes, all frames displayed are available in {country}. You can pick it up at one of our branches.",
  "product.faq2Q": "Do you add new frames regularly?",
  "product.faq2A": "Yes, new stylish frames arrive every week in all Lapaire stores.",
  "product.faq3Q": "How long to receive my glasses?",
  "product.faq3A": "Your glasses are usually ready within 24 to 72 hours depending on the correction needed.",
  "product.faq4Q": "Can I get an eye test in branch?",
  "product.faq4A": "Yes, the eye test at Lapaire is completely free with no obligation.",
  "product.faq5Q": "Can I send my prescription via WhatsApp?",
  "product.faq5A": "Yes, you can send your prescription directly via WhatsApp to our team.",
  "product.backToGlasses": "Back to glasses",
  "product.bookEyeTest": "Book a free eye test",
  "product.step": "Step {n}",
};

const translations: Record<string, TranslationKeys> = { fr, en };

export function t(key: keyof TranslationKeys, lang: "fr" | "en" = "fr"): string {
  return translations[lang]?.[key] ?? translations["fr"]?.[key] ?? key;
}

export type { TranslationKeys };
